module.exports = __webpack_public_path__ + "assets/favicon.773342b5b2fe208179bc6192b362a057.ico";